export enum PayableState {
    DRAFT = 'Draft',
    PENDING_APPROVAL = 'Pending Approval',
    APPROVED = 'Approved',
    PAYMENT_MARKED_AS_PAID = 'Marked As Paid',
    CHECK_PRINTED = 'Check Printed',
    APPROVAL_DENIED = 'Approval Denied',
    PAYMENT_SCHEDULED = 'Scheduled',
    PAYMENT_SENT = 'Sent',
    PAYMENT_PROCESSING = 'Processing',
    PAYMENT_PROCESSED = 'Processed',
    PAYMENT_DECLINED = 'Declined',
    PAYMENT_CANCELLED = 'Cancelled'
}
